import React from "react";

/**
 * Official maintayn house icon, cropped from the brand lockup.
 * - "onLight" (default): dark house for light backgrounds
 * - "onDark": white house for dark backgrounds (sidebar, dark hero panels)
 */
export function LogoIcon({ className = "", size = 28, variant = "onLight" }) {
    const src = variant === "onDark" ? "/maintayn-icon-ondark.png" : "/maintayn-icon-onlight.png";
    return (
        <img
            src={src}
            alt="maintayn"
            style={{ height: size, width: "auto" }}
            className={`inline-block select-none ${className}`}
            draggable={false}
        />
    );
}

/**
 * Full brand mark (icon + wordmark).
 * - "onLight" (default): dark wordmark for light backgrounds
 * - "onDark": white wordmark for dark backgrounds
 */
export function Logo({ className = "", size = 56, variant = "onLight" }) {
    const src = variant === "onDark" ? "/maintayn-logo-ondark.png" : "/maintayn-logo-onlight.png";
    return (
        <img
            src={src}
            alt="maintayn"
            style={{ height: size, width: "auto" }}
            className={`inline-block select-none ${className}`}
            draggable={false}
        />
    );
}

/**
 * Icon-only variant (alias of LogoIcon, kept for call-site clarity).
 */
export function LogoMark({ className = "", size = 28, variant = "onLight" }) {
    return <LogoIcon className={className} size={size} variant={variant} />;
}

export default Logo;
